module.exports = __webpack_public_path__ + "static/opened-clicks-3d3b2fe155a7eaf1ff32f856a2671fe7.png";